import { useDeviceAccessQuery } from '@/generated/graphql';
import { useDeviceSignalVariables } from '@/hooks/useDeviceIdentity';
import { useBansEnabled } from '@/hooks/useBansEnabled';

export function useDeviceAccess(engagementId?: string | null) {
  const { bansEnabled } = useBansEnabled();
  const { ready, variables } = useDeviceSignalVariables();
  const { data, loading } = useDeviceAccessQuery({
    skip: !bansEnabled || !engagementId || !ready,
    variables: {
      engagementId: engagementId || '',
      ...variables,
    },
  });
  return {
    allowed: !bansEnabled || (data?.deviceAccess.allowed ?? true),
    message:
      data?.deviceAccess.message || 'Submissions are disabled for this device.',
    loading: bansEnabled && (!ready || loading),
  };
}
